import type { Feature } from '@luna/gatekeeper';

export const reprintPinFocusPage: Feature = {
    enabled: true,
    _description: 'Displays the refactored reprintPin feature in the card services list',
};
